import { stats } from "@/mocks/doujinshi";

const heroImage =
  "https://readdy.ai/api/search-image?query=a%20warm%20stylized%20illustration%20of%20a%20stack%20of%20colorful%20anime%20fan%20comic%20books%20and%20art%20albums%20with%20comic%20panels%20and%20drawings%20floating%20around%2C%20cozy%20creative%20atmosphere%2C%20terracotta%20coral%20amber%20and%20cream%20palette%2C%20soft%20warm%20lighting%2C%20artistic%20and%20abstract%2C%20editorial%20composition&width=1600&height=900&seq=hero-main-01&orientation=landscape";

export default function Hero() {
  const onSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    document.getElementById("trending")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative flex min-h-[560px] w-full items-center md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="同人志典藏站：漫画本与画集合集在线阅读平台"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/55"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 pb-6 pt-28 text-center md:pt-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-200/50 bg-background-50/15 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
          <i className="ri-vip-crown-2-line text-accent-300"></i>
          漫画本 · 画集 · 四格 · 条漫 · 短篇合集
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-snug text-background-50 md:text-5xl md:leading-tight">
          同人志典藏站
          <span className="mt-1 block text-xl font-medium text-background-100 md:text-2xl">
            按格式打包 · 一键整本阅读
          </span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          无需四处寻找资源，点击即可整本翻阅。我们整理打包最完整的同人漫画、插画画集、四格漫画、
          网络条漫与短篇合集，方便你一次看全、慢慢收藏。
        </p>

        <form
          onSubmit={onSearch}
          className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row sm:items-center"
        >
          <label className="flex flex-1 items-center gap-3 rounded-md bg-background-50 px-4 py-3">
            <i className="ri-search-line text-lg text-foreground-600"></i>
            <input
              type="search"
              name="q"
              placeholder="搜索作品、作者社团或题材…"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
              aria-label="搜索作品"
            />
          </label>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            开始浏览
          </button>
        </form>

        <dl className="mx-auto mt-10 grid max-w-3xl grid-cols-2 gap-6 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label}>
              <dt className="font-label text-2xl text-accent-300 md:text-3xl">{s.value}</dt>
              <dd className="mt-1 text-xs text-background-100/85">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>

      <a
        href="#formats"
        aria-label="向下滚动浏览格式分类"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-2xl text-background-100/80"
      >
        <i className="ri-arrow-down-line animate-bounce"></i>
      </a>
    </section>
  );
}